import { ApiAccount, Account, GrowAccount, CustomerAccount } from './account.interface';

export function transformAccount(apiAccount: ApiAccount): Account {
  return apiAccount.kind === 'grow' ? transformGrowAccount(apiAccount) : transformCustomerAccount(apiAccount);
}

export function transformGrowAccount(api: ApiAccount): GrowAccount {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const {
    deposit_this_year,
    active,
    edit_mode,
    has_low_investment_balance,
    is_yova_yellow,
    inyova_fee,
    max_contribution_level,
    next_strategy_change_on,
    tutorial_seen,
    on_hold,
    converted_after_deadline,
    strategy_edit_mode_disabled_at,
    strategy_edit_mode_enabled_at,
    show_eve2_explanation_modal,
    risk_recheck_visible,
    liberty_account,
    liquidation_only,
    ...rest
  } = api;
  /* eslint-enable @typescript-eslint/no-unused-vars */

  return {
    ...rest,
    kind: 'grow'
  };
}

function transformCustomerAccount(api: ApiAccount): CustomerAccount {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const {
    monthly_investment,
    investment_risk_consent,
    fees_consent,
    reporting_timestamp,
    portfolio_value,
    portfolio_value_chf,
    portfolio_value_eur,
    portfolio_value_eur_chf,
    combined_expected_return,
    inyova_and_custody_fees,
    product_costs,
    commitments_made,
    eur_exchange_rate,
    ...rest
  } = api;
  /* eslint-enable @typescript-eslint/no-unused-vars */

  return {
    ...rest,
    kind: api.kind as Exclude<ApiAccount['kind'], 'grow'>
  };
}
